export default __webpack_public_path__ + "static/media/Logo_small.9ec983b8.png";